import { render, staticRenderFns } from "./confirm-step.vue?vue&type=template&id=317977c2&scoped=true&lang=pug&"
import script from "./confirm-step.vue?vue&type=script&lang=js&"
export * from "./confirm-step.vue?vue&type=script&lang=js&"
import style0 from "./confirm-step.vue?vue&type=style&index=0&id=317977c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317977c2",
  null
  
)

export default component.exports